<template>
  <div class="custom-tags">
    <input
      type="text"
      class="form-control"
      :placeholder="placeholder"
      v-model="newTag"
      @keydown.enter.prevent="addTag"
    />
    <div class="tags-container mb-2">
      <span v-for="(tag, index) in tags" :key="index" class="tag">
        {{ tag }}
        <button type="button" class="remove-tag" @click="removeTag(index)">
          &times;
        </button>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomTags",
  props: {
    defaultTags: {
      type: Array,
      default: [],
    },
    placeholder: {
      type: String,
      default: "Add tag...",
    },
  },
  data() {
    return {
      newTag: "",
      tags: [],
    };
  },
  created() {
    this.tags = this.defaultTags;
  },
  watch: {
    tags() {
      this.$emit("updateTags", this.tags);
    },
  },
  methods: {
    addTag() {
      if (this.newTag.trim()) {
        this.tags.push(this.newTag.trim());
        this.newTag = "";
      }
    },
    removeTag(index) {
      this.tags.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.custom-tags {
  width: 100%;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.tag {
  background-color: #e9ecef;
  border-radius: 4px;
  padding: 4px 8px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.remove-tag {
  background: none;
  border: none;
  color: #666;
  font-size: 16px;
  padding: 0;
  cursor: pointer;
  line-height: 1;
}

.remove-tag:hover {
  color: #dc3545;
}
</style>
